<template>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        labelWidth="180px"
        labelPosition="left"
        class="webhook-form"
    >
        <fieldset class="mb-4">
            <legend>{{ $l10n.__('Configurer le webhook') }}</legend>
            <slot name="endpoint"></slot>
        </fieldset>
        <slot name="format"></slot>
        <fieldset>
            <legend>{{ $l10n.__('Configurer les notifications envoyées au webhook') }}</legend>
            <slot name="configDescription"></slot>
            <slot name="configuration">
                <el-tabs tabPosition="left" type="card" class="webhooks-tabs mt-4">
                    <el-tab-pane v-for="log in parentLogs" :key="log.id" :label="log.description">
                        <template #label>
                            <span class="mr-2">{{ log.description }}</span>
                            <el-tag
                                effect="dark"
                                type="warning"
                                size="small"
                                class="flex-item-right"
                            >
                                <slot name="tagEvents" :currentLog="log"></slot>
                            </el-tag>
                        </template>
                        <!-- Content of right tab -->
                        <slot name="events" :log="log"></slot>
                    </el-tab-pane>
                </el-tabs>
            </slot>
        </fieldset>
        <div class="margin-modal">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="closeModal"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                class="ml-2"
                @click="submit"
            />
        </div>
    </el-form>
</template>

<script>
export default {
    props: {
        logs: {
            type: Array,
            required: false,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        rules: {
            type: Object,
            required: true,
            default: () => {},
        },
    },
    computed: {
        parentLogs() {
            return this.logs.filter((log) => _.isNil(log.parent));
        },
    },
    methods: {
        closeModal() {
            EventBus.emit('webhook:close');
        },
        submit() {
            this.$refs['form'].validate((valid) => {
                if (!valid) {
                    document.querySelector('.el-dialog__wrapper').scrollTo({
                        top: document.querySelector('.el-form-item,.is-error').offsetTop,
                        behavior: 'smooth',
                    });
                    return false;
                }
                this.$emit('submit');
            });
        },
    },
};
</script>
<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.webhooks-tabs {
    .el-tabs__item {
        line-height: 40px;
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.is-active {
            background-color: $primary;
            color: $white;
        }
    }

    .el-tabs__nav-scroll {
        overflow: auto !important;
    }

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
        display: none;
    }

    .el-tabs__nav-wrap {
        padding: 0 !important;
    }

    &.el-tabs {
        .el-tabs__nav-scroll,
        .el-tabs__nav-wrap.is-left,
        .el-tabs__header.is-left {
            height: auto;
        }
    }
}

.webhook-form {
    .el-form-item__label {
        line-height: 32px;
    }
    .margin-modal {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        padding-top: 24px;
    }
}
</style>
